<template>
  <div>
    <components
        :is="stepsList[active].component"
        :renderData="renderData"
        :loading="loading"
        class="component"
        ref="components"
        @cancel="cancel"
        @previousStep="previousStep"
        @confirm="confirm"
        @submit="submit"
        ></components>


 </div>
</template>
<script>
import { searchByCustomerName } from '@/api/domain/customers'
import config from '../config'
import masterOrderSignConfig from '../config/masterOrderSign'
import masterOrderLeaseConfig from '../config/masterOrderLease'
import selectCustomerConfig from '../config/selectCustomer'
import { AddleaseOrder } from '@/api/carManage'

export default {
  components: {
  },
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const { stepsList, previewList } = config.call(this)
    // 选择客户
    const {
      customerFormList,
      customerFormModel,
      customerRules,
      customerTextList,
      customerTextModel,
    } = selectCustomerConfig.call(this)
    // 主订单签约
    const {
      orderSignFormList,
      orderSignRules,
      orderSignModel,
      orderSignPreviewList,
    } = masterOrderSignConfig.call(this)
    // 主订单租赁设置
    const {
      leaseFormList,
      leaseModel,
    } = masterOrderLeaseConfig.call(this)
    return {
      stepsList,
      previewList,
      // 选择客户
      customerFormList,
      customerFormModel,
      customerRules,
      customerTextList,
      customerTextModel,
      // 主订单签约
      orderSignFormList,
      orderSignRules,
      orderSignModel,
      orderSignPreviewList,
      // 主订单租赁设置
      leaseFormList,
      leaseModel,
      topPreviewModel: {},
      // eslint-disable-next-line vue/no-unused-properties
      currentPreviewList: [],
      carProviderList: [],
      loading: false,
    }
  },
  computed: {
    renderData() {
      const {
        customerFormList,
        customerFormModel,
        customerRules,
        customerTextList,
        customerTextModel,
        orderSignFormList,
        orderSignRules,
        orderSignModel,
        leaseFormList,
        leaseModel,
        topPreviewModel,
        orderSignPreviewList,
        previewList,
      } = this
      return {
        list: {
          customerFormList,
          customerTextList,
          orderSignFormList,
          leaseFormList,
          orderSignPreviewList,
          previewList,
        },
        model: {
          topPreviewModel,
          customerFormModel,
          customerTextModel,
          orderSignModel,
          leaseModel,
          entRentOrderId: '',
        },
        rules: {
          customerRules,
          orderSignRules,
        },
      }
    },
  },
  watch: {
    orderSignFormList: {
      handler(val) {
        this.renderData.model.orderSignModel.contractAttachment = val[2].elConfig.fileList && val[2].elConfig.fileList.length ? val[2].elConfig.fileList : ''
      },
      deep: true,
    },
  },
  methods: {
    // 客户模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    customerNameRemoteMethod(val) {
      if (val.length < 1) return
      this.getCustomerList(val)
    },
    // 客户选择
    // eslint-disable-next-line vue/no-unused-properties
    customerNameChange(id) {
      const { customerTextModel } = this.renderData.model
      if (id) {
        this.carProviderList.forEach((item) => {
          if (item.id === id) {
            customerTextModel.customerName = item.customerName
            customerTextModel.customerId = item.id || ''
            customerTextModel.creditCode = item.creditCode
          }
        })
      } else {
        for (const key in customerTextModel) {
          customerTextModel[key] = ''
        }
        this.getCustomerList()
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    tipsClick() {
      // 当前逻辑出现在 主订单创建过程中 只有企业账户会走到这里
      window.open(
        '/driver/customerManage/add/company',
        '_blank',
      )
    },
    cancel() {
      this.$emit('cancel')
    },
    previousStep() {
      this.$emit('previousStep')
    },
    getParams() {
      const { customerFormModel, customerTextModel, orderSignModel, leaseModel } = this.renderData.model
      const params = {
        ...customerFormModel,
        ...customerTextModel,
        ...orderSignModel,
        ...leaseModel,
      }
      if (params.contractDate && params.contractDate.length) {
        params.contractStartDate = params.contractDate[0]
        params.contractEndDate = params.contractDate[1]
      }
      params.contractAttachment = this.getUoloadCommonFileData(this.orderSignFormList[2].elConfig.fileList)
      delete params.creditCode
      delete params.contractDate
      return params
    },
    confirm() {
      this.$emit('confirm')
    },
    // 提交
    submit() {
      this.$refs.components.$refs.baseInfo.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.loading = true
        AddleaseOrder({ ...this.getParams() }).then((res) => {
          const { data, code } = res
          this.loading = false
          if (code === 1) {
            this.renderData.model.entRentOrderId = data
            this.$emit('submit')
          }
        }).finally(() => {
          this.loading = false
        })
      })
    },
    getCustomerList(val) {
      searchByCustomerName({
        customerName: val,
        customerType: 2,
        customerState: 1, // 客户状态 0禁用 1启用
      }).then((res) => {
        const { data } = res
        this.$refs.components.$refs?.baseInfo?.setItemData({ elConfigKey: 'list', key: 'customerId', data })
        this.carProviderList = data || []
      })
    },
  },
  mounted() {
    this.getCustomerList()
  },
}
</script>
